import { useFormik, Form, FormikProvider } from 'formik';
import { Button, Input, Select } from 'styled';
import InputField from 'components/formik/InputField';
import Model from 'components/Modal';
import { createDocument, getAllData, getById, updateDocumentByID } from 'apis/customApiHandler';
import { useQuery, useQueryClient } from 'react-query';
import toast from 'react-hot-toast';
import { useCallback, useEffect, useState } from 'react';
import ReactSelect from 'react-select';
import Add from './add';

const Edit = ({ handleClick, data, desable }) => {
  const [doc, setDoc] = useState(null);
  const getDoc = async()=>{
    const response = await createDocument("manage-dtp/findOne", {id: data._id});
    if(response?.data) setDoc({...response?.data, fleet: response?.data.fleet._id, hub: response?.data.hub._id, points: response?.data?.points})
  }
  useEffect(()=>{
     getDoc();
  }, [])

  return (
    doc!==null && <Add handleClick={handleClick} data = {doc} desable={desable}/>
  )
};

export default Edit;
